// Footer mirroring inflexxionhealth.com: newsletter signup (HubSpot form),
// quick links, Connect with Us (email, social, LegitScript seal, logo), and
// the legal bottom bar.
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

// The same HubSpot newsletter form the marketing site embeds in its footer.
const HUBSPOT_PORTAL_ID = '49847627';
const HUBSPOT_FORM_ID = '3249f90c-fdb9-4ab5-bb27-d756cff3bef3';
const HUBSPOT_FORM_SCRIPT = `https://js.hsforms.net/forms/embed/developer/${HUBSPOT_PORTAL_ID}.js`;

const quickLinks = [
  { href: 'https://inflexxionhealth.com/book-your-visit-new#step-1', text: 'Book Your Visit' },
  { href: 'https://inflexxionhealth.com/symptoms-we-treat', text: 'Symptoms We Treat' },
  { href: 'https://inflexxionhealth.com/consultation-services', text: 'Our Consultation Services' },
  { href: 'https://inflexxionhealth.com/our-care-team', text: 'Our Care Team' },
  { href: 'https://inflexxionhealth.com/our-custom-rx', text: 'Our Custom Rx' },
  { href: 'https://inflexxionhealth.com/our-vision', text: 'Our Vision' },
  { href: 'https://inflexxionhealth.com/blog', text: 'Blog' },
  { href: 'https://inflexxionhealth.com/faqs', text: 'FAQs' },
];

const socialLinks = [
  { href: 'https://www.facebook.com/profile.php?id=61575958201144', label: 'Follow us on Facebook', icon: faFacebookF },
  { href: 'https://www.linkedin.com/company/inflexxion-health/', label: 'Follow us on LinkedIn', icon: faLinkedinIn },
  { href: 'https://www.instagram.com/inflexxion.health/', label: 'Follow us on Instagram', icon: faInstagram },
];

const legalLinks = [
  { href: 'https://inflexxionhealth-49847627.hs-sites.com/privacy-policy', text: 'Privacy Policy' },
  { href: 'https://inflexxionhealth-49847627.hs-sites.com/terms-and-conditions', text: 'Terms & Conditions' },
  { href: 'https://inflexxionhealth-49847627.hs-sites.com/consumer-health-data-privacy-policy', text: 'Consumer Health Data' },
];

const Footer = () => {
  const supportEmail = process.env.REACT_APP_INFLEXXIONHEALTH_SUPPORT_EMAIL;
  const logoUrl = process.env.PUBLIC_URL + '/logo-horizontal-transparent.png';

  // Load the HubSpot forms embed once; it hydrates the .hs-form-html div below.
  useEffect(() => {
    if (document.querySelector(`script[src="${HUBSPOT_FORM_SCRIPT}"]`)) return;
    const script = document.createElement('script');
    script.src = HUBSPOT_FORM_SCRIPT;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__col site-footer__col--form">
          <div
            className="hs-form-html"
            data-region="na1"
            data-form-id={HUBSPOT_FORM_ID}
            data-portal-id={HUBSPOT_PORTAL_ID}
          ></div>
        </div>

        <nav className="site-footer__col site-footer__col--links" aria-label="Footer">
          <ul className="site-footer__menu">
            {quickLinks.map(({ href, text }) => (
              <li key={text}>
                <a href={href}>{text}</a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="site-footer__col site-footer__col--connect">
          <h5 className="site-footer__heading">Connect with Us</h5>
          <p className="site-footer__email">
            Email Address:
            <br />
            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </p>

          <div className="site-footer__social">
            {socialLinks.map(({ href, label, icon }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={icon} aria-hidden="true" />
                <span className="sr-only">{label}</span>
              </a>
            ))}
          </div>

          <div className="site-footer__legitscript">
            <a
              href="https://www.legitscript.com/websites/?checker_keywords=inflexxionhealth.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://static.legitscript.com/seals/45616222.png"
                alt="LegitScript approved"
                width="100"
                loading="lazy"
              />
            </a>
          </div>

          <a href="https://inflexxionhealth.com" aria-label="Inflexxion Health home">
            <img src={logoUrl} alt="Inflexxion Health" className="site-footer__logo" loading="lazy" />
          </a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="site-footer__bottom-inner">
          <span className="site-footer__copyright">
            &copy; {new Date().getFullYear()} InflexxionHealth Corp. All Rights Reserved
          </span>
          <ul className="site-footer__legal">
            {legalLinks.map(({ href, text }) => (
              <li key={text}>
                <a href={href}>{text}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
